import { useMemo } from 'react'
import * as React from 'react'

import useLocallyPersistedState from 'hooks/useLocallyPersistedState'
import noop from 'lib/function/noop'

type ViewMode = 'detail' | 'compact'
type ViewModeContextValue = {
  viewMode: ViewMode
  setViewMode: (mode: ViewMode) => void
  toggleViewMode: () => void
}

export const ViewModeContext = React.createContext<ViewModeContextValue>({
  viewMode: 'detail',
  setViewMode: noop,
  toggleViewMode: noop,
})

export function ViewModeContextProvider({
  children,
}: React.PropsWithChildren<{ }>) {
  const [viewMode, setViewMode] = useLocallyPersistedState<ViewMode>({
    key: 'tripPlannerViewMode',
    defaultValue: 'detail',
    version: 1,
    returnDefaultBeforeRestoring: true,
  })

  const value = useMemo<ViewModeContextValue>(() => {
    return {
      viewMode,
      setViewMode,
      toggleViewMode: () =>
        setViewMode((mode) => (mode === 'detail' ? 'compact' : 'detail')),
    }
  }, [viewMode, setViewMode])

  return (
    <ViewModeContext.Provider value={value}>
      {children}
    </ViewModeContext.Provider>
  )
}
